import { render, staticRenderFns } from "./OpendataWizardStep.vue?vue&type=template&id=11a74a8f&"
import script from "./OpendataWizardStep.vue?vue&type=script&lang=js&"
export * from "./OpendataWizardStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports